export default "__VITE_ASSET__DnghekPH__"